<app-modal-window title="Укажите причину"
                  [actions]="true"
                  [disabledConfirm]="reason.invalid"
                  (close)="close()"
                  (confirm)="cancelPayout()">
  <div class='reason-content'>
    <mat-form-field appearance='outline' class="reason">
      <mat-label>Причина</mat-label>
<!--      [matAutocomplete]="default_reasons"-->
      <input matInput type='text' placeholder='Причина'
             [formControl]='reason'>
<!--      <mat-autocomplete autoActiveFirstOption #default_reasons="matAutocomplete">-->
<!--        <mat-option *ngFor="let item of defaultReasons" [value]="item">-->
<!--          {{item}}-->
<!--        </mat-option>-->
<!--      </mat-autocomplete>-->
    </mat-form-field>
  </div>
</app-modal-window>
